module.exports = __webpack_public_path__ + "img/stage-6.6abb68aa.png";